/* RescueNation — static frosted Europe-map background.
   Replaces the old animated network canvas: every [data-rn-network] canvas now
   shows the still map image with a frosted-glass look (matches the hero video).
   The image URL can be overridden per element via data-rn-bg="...";
   IMG below is only the fallback. */
(function () {
  var IMG = 'https://cdn.shopify.com/s/files/1/0995/5894/9248/files/hf_20260727_142115_c68e4ad6-eb29-48a3-a5fd-8a9ca43a355f.png?v=1785166046';
  function apply(c) {
    var url = (c.dataset && c.dataset.rnBg) || IMG;
    if (!url) { return; }
    var s = c.style;
    s.setProperty('background-image', 'url(' + url + ')', 'important');
    s.setProperty('background-size', 'cover', 'important');
    s.setProperty('background-position', 'center', 'important');
    s.setProperty('filter', 'blur(4px) brightness(.9) saturate(1.1)', 'important');
    s.setProperty('transform', 'scale(1.03)', 'important');
    s.setProperty('mix-blend-mode', 'normal', 'important');
    s.setProperty('opacity', '1', 'important');
  }
  function initAll() {
    document.querySelectorAll('[data-rn-network]').forEach(apply);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
